import comp from "./AssessmentGradeScaleTool";
export default comp;
